'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CwLinearProgressBarMode = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwLinearProgressBar = require('./CwLinearProgressBar.scss');

var _CwLinearProgressBar2 = _interopRequireDefault(_CwLinearProgressBar);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwLinearProgressBarMode = exports.CwLinearProgressBarMode = {
  DETERMINATE: 'determinate',
  INDETERMINATE: 'indeterminate'
};

/* https://codepen.io/holdencreative/pen/vEVbwv */
var CwLinearProgressBar = function CwLinearProgressBar(props) {
  var determinateMode = props.mode === CwLinearProgressBarMode.DETERMINATE;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(props.className, _CwLinearProgressBar2.default.wrap), style: props.style },
    _react2.default.createElement('div', {
      className: determinateMode ? _CwLinearProgressBar2.default.determinate : _CwLinearProgressBar2.default.indeterminate,
      style: determinateMode ? { width: props.value + '%' } : null
    })
  );
};

CwLinearProgressBar.propTypes = {
  /**
  * The mode of show your progress, indeterminate for when
  * there is no value for progress.
  */
  mode: _propTypes2.default.oneOf([CwLinearProgressBarMode.DETERMINATE, CwLinearProgressBarMode.INDETERMINATE]),
  /**
   * The [0-100] percent value of progress, only applicable in determinate mode.
   */
  value: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string
};

CwLinearProgressBar.defaultProps = {
  mode: 'indeterminate'
};

exports.default = CwLinearProgressBar;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwlinearprogressbar/CwLinearProgressBar.js
// module id = 839
// module chunks = 10